module.exports = __webpack_public_path__ + "static/media/GY.cb36adae.svg";